module.exports = __webpack_public_path__ + "media/icons/favourite-off-9bc3dd26.png";